module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("8EHDU"))).then(() => parcelRequire('gDR9B'));